import "../../src/pages/Skills/Skills.css";

//  FrontEnd Categories ↓↓↓↓**
const categories = {
  webDev: "categories.fe.webDev",
  feTools: "categories.fe.feTools",
  versionControlSoftware: "categories.fe.versionControlSoftware",
  sourceCodeHosting: "categories.fe.sourceCodeHosting",
  dependenciasManagment: "categories.fe.dependenciasManagment",
  softwareDevTools: "categories.fe.softwareDevTools",
  ides: "categories.fe.ides",
  webDevTools: "categories.fe.webDevTools",
  cloudWebDevPlatforms: "categories.fe.cloudWebDevPlatforms",
  baasPlatforms: "categories.fe.baasPlatforms",
  seoTools: "categories.fe.seoTools",
  webDevFrameworks: "categories.fe.webDevFrameworks",

  htmlCat: "categories.fe.htmlCat",
  pugCat: "categories.fe.pugCat",
  cssCat: "categories.fe.cssCat",
  jsCat: "categories.fe.jsCat",
  reactJsCat: "categories.fe.reactJsCat",
  reduxCat: "categories.fe.reduxCat",
  reactRouterCat: "categories.fe.reactRouterCat",
  tailwindCat: "categories.fe.tailwindCat",
  sassCat: "categories.fe.sassCat",
  muiCat: "categories.fe.muiCat",
  bootstrapCat: "categories.fe.bootstrapCat",
  wordpressCat: "categories.fe.wordpressCat",
  gitCat: "categories.fe.gitCat",
  gitHubCat: "categories.fe.gitHubCat",
  npmCat: "categories.fe.npmCat",
  vscCat: "categories.fe.vscCat",
  webstormCat: "categories.fe.webstormCat",
  codepenCat: "categories.fe.codepenCat",
  codesandboxCat: "categories.fe.codesandboxCat",
  vercelCat: "categories.fe.vercelCat",
  netlifyCat: "categories.fe.netlifyCat",
  firebaseCat: "categories.fe.firebaseCat",
  gdtCat: "categories.fe.gdtCat",
  gscCat: "categories.fe.gscCat",
  nextJsCat: "categories.fe.nextJsCat",

  //  BackEnd Categories  ↓↓↓↓**
  nodeCat: "categories.be.nodeCat",
  expressCat: "categories.be.expressCat",
  pythonCat: "categories.be.pythonCat",
  djangoCat: "categories.be.djangoCat",
  postgresqlCat: "categories.be.postgresqlCat",
  mongodbCat: "categories.be.mongodbCat",
  mysqlCat: "categories.be.mysqlCat",
  sqliteCat: "categories.be.sqliteCat",
  // npmBeCat: "",
  nodemailerCat: "categories.be.nodemailerCat",
  mailtrapCat: "categories.be.mailtrapCat",
  restCat: "categories.be.restCat",
  httpCat: "categories.be.httpCat",
  postmanCat: "categories.be.postmanCat",
  jwtCat: "categories.be.jwtCat",
  pycharmCat: "categories.be.pycharmCat",
  herokuCat: "categories.be.herokuCat",
  firebaseBeCat: "categories.fe.firebaseCat",
  railwayCat: "categories.be.railwayCat",
  cpanelCat: "categories.be.cpanelCat",
};

//  FrontEnd tools type of **
const typeOfTech = {
  htmlTech: "typeOfTech.fe.htmlTech",
  pugTech: "typeOfTech.fe.pugTech",
  cssTech: "typeOfTech.fe.cssTech",
  jsTech: "typeOfTech.fe.jsTech",
  reactJsTech: "typeOfTech.fe.reactJsTech",
  reduxTech: "typeOfTech.fe.reduxTech",
  reactRouterTech: "typeOfTech.fe.reactRouterTech",
  tailwindTech: "typeOfTech.fe.tailwindTech",
  sassTech: "typeOfTech.fe.sassTech",
  muiTech: "typeOfTech.fe.muiTech",
  bootstrapTech: "typeOfTech.fe.bootstrapTech",
  wordpressTech: "typeOfTech.fe.wordpressTech",
  gitTech: "typeOfTech.fe.gitTech",
  gitHubTech: "typeOfTech.fe.gitHubTech",
  npmTech: "typeOfTech.fe.npmTech",
  vscTech: "typeOfTech.fe.vscTech",
  webstormTech: "typeOfTech.fe.webstormTech",
  codepenTech: "typeOfTech.fe.codepenTech",
  codesandboxTech: "typeOfTech.fe.codesandboxTech",
  vercelTech: "typeOfTech.fe.vercelTech",
  netlifyTech: "typeOfTech.fe.netlifyTech",
  firebaseTech: "typeOfTech.fe.firebaseTech",
  gdtTech: "typeOfTech.fe.gdtTech",
  gscTech: "typeOfTech.fe.gscTech",
  nextJsTech: "typeOfTech.fe.nextJsTech",

  // BackEnd tools type of
  nodeTech: "typeOfTech.be.nodeTech",
  expressTech: "typeOfTech.be.expressTech",
  pythonTech: "typeOfTech.be.pythonTech",
  djangoTech: "typeOfTech.be.djangoTech",
  postgresqlTech: "typeOfTech.be.postgresqlTech",
  mongodbTech: "typeOfTech.be.mongodbTech",
  mysqlTech: "typeOfTech.be.mysqlTech",
  sqliteTech: "typeOfTech.be.sqliteTech",
  nodemailerTech: "typeOfTech.be.nodemailerTech",
  mailtrapTech: "typeOfTech.be.mailtrapTech",
  restTech: "typeOfTech.be.restTech",
  httpTech: "typeOfTech.be.httpTech",
  postmanTech: "typeOfTech.be.postmanTech",
  jwtTech: "typeOfTech.be.jwtTech",
  pycharmTech: "typeOfTech.be.pycharmTech",
  herokuTech: "typeOfTech.be.herokuTech",
  firebaseBeTech: "typeOfTech.fe.firebaseTech",
  railwayTech: "typeOfTech.be.railwayTech",
  cpanelTech: "typeOfTech.be.cpanelTech",
};

// Descripton of Technologies
const techDescription = {
  // Descriptions frontEnd technologies
  htmlDesc: "techDescription.fe.htmlDesc",
  pugDesc: "techDescription.fe.pugDesc",
  cssDesc: "techDescription.fe.cssDesc",
  jsDesc: "techDescription.fe.jsDesc",
  reactJsDesc: "techDescription.fe.reactJsDesc",
  reduxDesc: "techDescription.fe.reduxDesc",
  reactRouterDesc: "techDescription.fe.reactRouterDesc",
  tailwindDesc: "techDescription.fe.tailwindDesc",
  sassDesc: "techDescription.fe.sassDesc",
  muiDesc: "techDescription.fe.muiDesc",
  bootstrapDesc: "techDescription.fe.bootstrapDesc",
  wordpressDesc: "techDescription.fe.wordpressDesc",
  gitDesc: "techDescription.fe.gitDesc",
  gitHubDesc: "techDescription.fe.gitHubDesc",
  npmDesc: "techDescription.fe.npmDesc",
  vscDesc: "techDescription.fe.vscDesc",
  webstormDesc: "techDescription.fe.webstormDesc",
  codepenDesc: "techDescription.fe.codepenDesc",
  codesandboxDesc: "techDescription.fe.codesandboxDesc",
  vercelDesc: "techDescription.fe.vercelDesc",
  netlifyDesc: "techDescription.fe.netlifyDesc",
  firebaseDesc: "techDescription.fe.firebaseDesc",
  gdtDesc: "techDescription.fe.gdtDesc",
  gscDesc: "techDescription.fe.gscDesc",
  nextJsDesc: "techDescription.fe.nextJsDesc",

  // Descriptions BackEnd technologies
  nodeDesc: "techDescription.be.nodeDesc",
  expressDesc: "techDescription.be.expressDesc",
  pythonDesc: "techDescription.be.pythonDesc",
  djangoDesc: "techDescription.be.djangoDesc",
  postgresqlDesc: "techDescription.be.postgresqlDesc",
  mongodbDesc: "techDescription.be.mongodbDesc",
  mysqlDesc: "techDescription.be.mysqlDesc",
  sqliteDesc: "techDescription.be.sqliteDesc",
  nodemailerDesc: "techDescription.be.nodemailerDesc",
  mailtrapDesc: "techDescription.be.mailtrapDesc",
  restDesc: "techDescription.be.restDesc",
  httpDesc: "techDescription.be.httpDesc",
  postmanDesc: "techDescription.be.postmanDesc",
  jwtDesc: "techDescription.be.jwtDesc",
  pycharmDesc: "techDescription.be.pycharmDesc",
  herokuDesc: "techDescription.be.herokuDesc",
  firebaseBeDesc: "techDescription.fe.firebaseDesc",
  railwayDesc: "techDescription.be.railwayDesc",
  cpanelDesc: "techDescription.be.cpanelDesc",
};

export const skillsFE = [
  {
    id: 1,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    title: "HTML-5",
    alt: "HTML-5 logo",
    description: `${techDescription.htmlDesc}`,
    class: "icons",
    progress: 85,
    variant: "success",
    // category: `${categories.htmlCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.htmlTech}`,
    docs: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    id: 2,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpug-svgrepo-com.svg?alt=media&token=4dc4f301-2c8d-4152-b2a5-093c4ea23724",
    title: "PUG",
    alt: "pug logo",
    description: `${techDescription.pugDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.pugCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.pugTech}`,
    docs: "https://pugjs.org/api/getting-started.html",
  },
  {
    id: 3,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    title: "CSS-3",
    alt: "CSS-3 logo",
    description: `${techDescription.cssDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.cssCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.cssTech}`,
    docs: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    id: 4,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    title: "JAVASCRIPT",
    alt: "Javascript logo",
    description: `${techDescription.jsDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.jsCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.jsTech}`,
    docs: "https://developer.mozilla.org/en-US/docs/Web/JAVASCRIPT",
  },
  {
    id: 5,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    title: "REACT JS",
    alt: "React js logo",
    description: `${techDescription.reactJsDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.reactJsCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.reactJsTech}`,
    docs: "https://react.dev/",
  },
  {
    id: 6,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fredux-logo-svgrepo-com.svg?alt=media&token=12531cdc-c737-43e7-9494-bacab532fd09",
    title: "REDUX",
    alt: "Redux logo",
    description: `${techDescription.reduxDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.reduxCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.reduxTech}`,
    docs: "https://redux.js.org/",
  },
  {
    id: 7,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
    title: "REACT ROUTER",
    alt: "React Router logo",
    description: `${techDescription.reactRouterDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.reactRouterCat}`,
    category: `${categories.feTools}`,
    typeOfTech: `${typeOfTech.reactRouterTech}`,
    docs: "https://reactrouter.com/en/main",
  },
  {
    id: 8,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    title: "TAILWIND",
    alt: "Tailwind logo",
    description: `${techDescription.tailwindDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.tailwindCat}`,
    category: `${categories.feTools}`,
    typeOfTech: `${typeOfTech.tailwindTech}`,
    docs: "https://tailwindcss.com/",
  },
  {
    id: 9,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fsass-svgrepo-com.svg?alt=media&token=bd2e56f6-5ad4-4d9e-92c9-4e256a6e7833",
    title: "SASS",
    alt: "Sass logo",
    description: `${techDescription.sassDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.sassCat}`,
    category: `${categories.feTools}`,
    typeOfTech: `${typeOfTech.sassTech}`,
    docs: "https://sass-lang.com/documentation/",
  },
  {
    id: 10,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmaterial-ui-svgrepo-com.svg?alt=media&token=d9f03156-d62b-43b4-8265-026d65cbca23",
    title: "MUI",
    alt: "mui logo",
    description: `${techDescription.muiDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.muiCat}`,
    category: `${categories.feTools}`,
    typeOfTech: `${typeOfTech.muiTech}`,
    docs: "https://mui.com/material-ui/getting-started/overview/",
  },
  {
    id: 11,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fbootstrap.svg.svg?alt=media&token=d2cd69d3-f464-4646-8108-5fb9be6c3392",
    title: "BOOTSTRAP",
    alt: "Bootstrap logo",
    description: `${techDescription.bootstrapDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    // category: `${categories.bootstrapCat}`,
    category: `${categories.feTools}`,
    typeOfTech: `${typeOfTech.bootstrapTech}`,
    docs: "https://getbootstrap.com/docs/5.3/getting-started/introduction/",
  },
  {
    id: 12,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fwordpress-svgrepo-com.svg?alt=media&token=b537352d-cda5-4c99-84ae-319fd6a6ffdb",
    title: "WORDPRESS",
    alt: "Wordpress logo",
    description: `${techDescription.wordpressDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.wordpressCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.wordpressTech}`,
    docs: "https://wordpress.com/",
  },
  {
    id: 13,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fgit-svgrepo-com.svg?alt=media&token=3aabc077-af83-4871-ba95-3e4cde1d6ffa",
    title: "GIT",
    alt: "Git logo",
    description: `${techDescription.gitDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.gitCat}`,
    category: `${categories.versionControlSoftware}`,
    typeOfTech: `${typeOfTech.gitTech}`,
    docs: "https://git-scm.com/doc",
  },
  {
    id: 14,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FGithubBlack.svg?alt=media&token=1b6f7157-6f96-483c-91f8-4a89a4e25f7d",
    title: "GIT-HUB",
    alt: "Github logo",
    description: `${techDescription.gitHubDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.gitHubCat}`,
    category: `${categories.sourceCodeHosting}`,
    typeOfTech: `${typeOfTech.gitHubTech}`,
    docs: "https://docs.github.com/es",
  },
  {
    id: 15,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnpm-svgrepo-com.svg?alt=media&token=6b9a7f75-37b3-40dd-9c59-63c9769b9a5b",
    title: "NPM",
    alt: "npm logo",
    description: `${techDescription.npmDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.npmCat}`,
    category: `${categories.dependenciasManagment}`,
    typeOfTech: `${typeOfTech.npmTech}`,
    docs: "https://docs.npmjs.com/",
  },
  {
    id: 16,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvisual-studio-code-svgrepo-com.svg?alt=media&token=d7d44efb-d68d-4e19-8c39-f5f65151d726",
    title: "VSC",
    alt: "vsc logo",
    description: `${techDescription.vscDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    // category: `${categories.vscCat}`,
    category: `${categories.ides}`,
    typeOfTech: `${typeOfTech.vscTech}`,
    docs: "https://code.visualstudio.com/docs",
  },
  {
    id: 17,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fwebstorm-svgrepo-com.svg?alt=media&token=196fce6c-a0ed-4f5a-bee2-77304cc2f649",
    title: "WEBSTORM",
    alt: "Webstorm logo",
    description: `${techDescription.webstormDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.webstormCat}`,
    category: `${categories.ides}`,
    typeOfTech: `${typeOfTech.webstormTech}`,
    docs: "https://www.jetbrains.com/help/webstorm/getting-started-with-webstorm.html",
  },
  {
    id: 18,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcodepen-02-svgrepo-com.svg?alt=media&token=b78579dc-49fd-4db0-8a6e-fd685473d2a2",
    title: "CODEPEN",
    alt: "Codepen logo",
    description: `${techDescription.codepenDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.codepenCat}`,
    category: `${categories.webDevTools}`,
    typeOfTech: `${typeOfTech.codepenTech}`,
    docs: "https://blog.codepen.io/documentation/",
  },
  {
    id: 19,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcodesandbox-svgrepo-com.svg?alt=media&token=c6814bf2-93d5-40e1-a3d4-ea730be029c2",
    title: "CODESANDBOX",
    alt: "Codesandbox logo",
    description: `${techDescription.codesandboxDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.codesandboxCat}`,
    category: `${categories.webDevTools}`,
    typeOfTech: `${typeOfTech.codesandboxTech}`,
    docs: "https://codesandbox.io/docs/learn/introduction/overview",
  },
  {
    id: 20,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    title: "VERCEL",
    alt: "Vercel logo",
    description: `${techDescription.vercelDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.vercelCat}`,
    category: `${categories.cloudWebDevPlatforms}`,
    typeOfTech: `${typeOfTech.vercelTech}`,
    docs: "https://vercel.com/docs",
  },
  {
    id: 21,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31&_gl=1*zbm2m5*_ga*MTkyOTMxODgzNC4xNjgyMDkxNDc2*_ga_CW55HF8NVT*MTY4NTc2ODcyOS4xMC4xLjE2ODU3Njg3ODkuMC4wLjA.",
    title: "NEXT JS",
    alt: "logo",
    description: `${techDescription.nextJsDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.nextJsCat}`,
    category: `${categories.webDevFrameworks}`,
    typeOfTech: `${typeOfTech.nextJsTech}`,
    docs: "https://nextjs.org/docs",
  },

  {
    id: 22,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnetlify-svgrepo-com.svg?alt=media&token=2b403c92-7d50-45d2-b049-20c6f8285a3e",
    title: "NETLIFY",
    alt: "Netlify logo",
    description: `${techDescription.netlifyDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.netlifyCat}`,
    category: `${categories.cloudWebDevPlatforms}`,
    typeOfTech: `${typeOfTech.netlifyTech}`,
    docs: "https://docs.netlify.com/",
  },

  {
    id: 23,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    title: "FIREBASE",
    alt: "Firebase logo",
    description: `${techDescription.firebaseDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.firebaseCat}`,
    category: `${categories.baasPlatforms}`,
    typeOfTech: `${typeOfTech.firebaseTech}`,
    docs: "https://firebase.google.com/docs",
  },
  {
    id: 24,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fchrome-devtools-svgrepo-com.svg?alt=media&token=ceeaf800-4c13-42f4-999b-4a707f920c78",
    title: "CHROME DEV TOOLS",
    alt: "Chrome DevTools logo",
    description: `${techDescription.gdtDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.gdtCat}`,
    category: `${categories.webDev}`,
    typeOfTech: `${typeOfTech.gdtTech}`,
    docs: "https://developer.chrome.com/docs/devtools/",
  },
  {
    id: 25,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fgoogle-search-console%20(2).svg?alt=media&token=51a92400-ccab-4c86-8a28-12f818454075",
    title: "GOOGLE SEARCH CONSOLE",
    alt: "Google Search Console logo",
    description: `${techDescription.gscDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    // category: `${categories.gscCat}`,
    category: `${categories.seoTools}`,
    typeOfTech: `${typeOfTech.gscTech}`,
    docs: "https://developers.google.com/search/docs/monitor-debug/search-console-start",
  },
];

export const skillsBE = [
  {
    id: 1,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnodejs-1-logo-svgrepo-com.svg?alt=media&token=afa3c35d-425a-44d7-95bc-ca797548ba45",
    title: "NODE JS",
    alt: "Nodejs",
    description: `${techDescription.nodeDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.nodeCat}`,
    typeOfTech: `${typeOfTech.nodeTech}`,
    docs: "https://nodejs.org/en/docs",
  },
  {
    id: 2,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fexpress-svgrepo-com.svg?alt=media&token=0ac98956-4734-4662-92b6-15c83e71408e",
    title: "EXPRESS JS",
    alt: "Express JS",
    description: `${techDescription.expressDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.expressCat}`,
    typeOfTech: `${typeOfTech.expressTech}`,
    docs: "https://expressjs.com/",
  },
  {
    id: 3,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpython-svgrepo-com.svg?alt=media&token=dd35c257-b994-4350-8fb0-9226eb25e748",
    title: "PYTHON",
    alt: "Python logo",
    description: `${techDescription.pythonDesc}`,
    class: "icons",
    progress: 60,
    variant: "warning",
    category: `${categories.pythonCat}`,
    typeOfTech: `${typeOfTech.pythonTech}`,
    docs: "https://docs.python.org/3/",
  },
  {
    id: 4,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fdjango-svgrepo-com.svg?alt=media&token=13b31f65-df6d-4986-84ea-2d6abd0cc8d2",
    title: "DJANGO",
    alt: "Django logo",
    description: `${techDescription.djangoDesc}`,
    class: "icons",
    progress: 60,
    variant: "warning",
    category: `${categories.djangoCat}`,
    typeOfTech: `${typeOfTech.djangoTech}`,
    docs: "https://docs.djangoproject.com/en/4.2/",
  },
  {
    id: 5,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpostgresql-svgrepo-com%20(1).svg?alt=media&token=8294cc05-91ae-49c4-8418-d531fc8ca0b7",
    title: "POSTGRESQL",
    alt: "PostgreSQL logo",
    description: `${techDescription.postgresqlDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.postgresqlCat}`,
    typeOfTech: `${typeOfTech.postgresqlTech}`,
    docs: "https://www.postgresql.org/docs/",
  },
  {
    id: 6,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmongodb-svgrepo-com.svg?alt=media&token=12d49f5f-5031-43e4-abd8-aa14ae07565a",
    title: "MONGODB",
    alt: "MongoDB logo",
    description: `${techDescription.mongodbDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.mongodbCat}`,
    typeOfTech: `${typeOfTech.mongodbTech}`,
    docs: "https://www.mongodb.com/docs/",
  },
  {
    id: 7,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmysql-logo-svgrepo-com.svg?alt=media&token=1814a75d-62ad-4289-9c18-c8478fa245f5",
    title: "MYSQL",
    alt: "MySQL logo",
    description: `${techDescription.mysqlDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.mysqlCat}`,
    typeOfTech: `${typeOfTech.mysqlTech}`,
    docs: "https://docs.oracle.com/cd/E17952_01/index.html",
  },
  {
    id: 8,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fsqlite-svgrepo-com.svg?alt=media&token=68fe3035-c8a1-4a35-8cee-1b428bd69e37",
    title: "SQLITE",
    alt: "SQLite logo",
    description: `${techDescription.sqliteDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.sqliteCat}`,
    typeOfTech: `${typeOfTech.sqliteTech}`,
    docs: "https://www.sqlite.org/docs.html",
  },
  {
    id: 9,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnpm-svgrepo-com.svg?alt=media&token=6b9a7f75-37b3-40dd-9c59-63c9769b9a5b",
    title: "NPM",
    alt: "npm logo",
    description: `${techDescription.npmDesc}`,
    class: "icons",
    progress: 80,
    variant: "success",
    category: `${categories.npmCat}`,
    typeOfTech: `${typeOfTech.npmTech}`,
    docs: "https://docs.npmjs.com/",
  },
  {
    id: 10,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnodemailer.png?alt=media&token=dbb99316-6520-4902-a875-396cf8bcfe13",
    title: "NODEMAILER",
    alt: "Nodemailer logo",
    description: `${techDescription.nodemailerDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.nodemailerCat}`,
    typeOfTech: `${typeOfTech.nodemailerTech}`,
    docs: "https://nodemailer.com/",
  },
  {
    id: 11,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FmailtrapLogoNew.png?alt=media&token=1a96f29c-5193-400d-b633-173646855356",
    title: "MAILTRAP",
    alt: "Mailtrap logo",
    description: `${techDescription.mailtrapDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.mailtrapCat}`,
    typeOfTech: `${typeOfTech.mailtrapTech}`,
    docs: "https://api-docs.mailtrap.io/docs/mailtrap-api-docs/5tjdeg9545058-mailtrap-api",
  },
  {
    id: 12,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Frest-api-2.svg?alt=media&token=2329c405-f160-4d14-8e71-82b3bb786afe",
    title: "REST",
    alt: "Rest logo",
    description: `${techDescription.restDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.restCat}`,
    typeOfTech: `${typeOfTech.restTech}`,
    docs: "https://www.ics.uci.edu/~fielding/pubs/dissertation/rest_arch_style.htm",
  },
  {
    id: 13,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhttp-domain-svgrepo-com.svg?alt=media&token=44baeb1c-b021-42a6-accf-9bf19257f881",
    title: "HTTP",
    alt: "Http logo",
    description: `${techDescription.httpDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.httpCat}`,
    typeOfTech: `${typeOfTech.httpTech}`,
    docs: "https://www.iana.org/assignments/http-status-codes/http-status-codes.xhtml#http-status-codes-1",
  },
  {
    id: 14,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpostman-icon-svgrepo-com.svg?alt=media&token=79db5784-d0b9-447a-bf12-0170ab1bf11f",
    title: "POSTMAN",
    alt: "Postman Logo",
    description: `${techDescription.postmanDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.postmanCat}`,
    typeOfTech: `${typeOfTech.postmanTech}`,
    docs: "https://www.postman.com/api-documentation-tool/",
  },
  {
    id: 15,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjson-web-tokenlOGO.png?alt=media&token=03ad302b-4933-422a-a6fd-0f0f8984a26a",
    title: "JWT",
    alt: "Jwt logo",
    description: `${techDescription.jwtDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.jwtCat}`,
    typeOfTech: `${typeOfTech.jwtTech}`,
    docs: "https://jwt.io/introduction",
  },
  {
    id: 16,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjb-pycharm-svgrepo-com.svg?alt=media&token=7770d46d-381d-4c35-ab5e-6d2098e199cc",
    title: "PYCHARM",
    alt: "Pycharm logo",
    description: `${techDescription.pycharmDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.pycharmCat}`,
    typeOfTech: `${typeOfTech.pycharmTech}`,
    docs: "https://www.jetbrains.com/pycharm/guide/tips/quick-docs/",
  },
  {
    id: 17,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fheroku-svgrepo-com.svg?alt=media&token=593ebd1a-69be-4d19-b884-d843fc131343",
    title: "HEROKU",
    alt: "Heoku logo",
    description: `${techDescription.herokuDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.herokuCat}`,
    typeOfTech: `${typeOfTech.herokuTech}`,
    docs: "https://devcenter.heroku.com/categories/reference",
  },
  {
    id: 18,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    title: "FIREBASE",
    alt: "Firebase logo",
    description: `${techDescription.firebaseDesc}`,
    class: "icons",
    progress: 70,
    variant: "success",
    category: `${categories.firebaseCat}`,
    typeOfTech: `${typeOfTech.firebaseTech}`,
    docs: "https://firebase.google.com/docs",
  },
  {
    id: 19,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Frailway.svg?alt=media&token=2c09749f-d2c2-4c92-be01-8893405e6952",
    title: "RAILWAY",
    alt: "Railway logo",
    description: `${techDescription.railwayDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.railwayCat}`,
    typeOfTech: `${typeOfTech.railwayTech}`,
    docs: "https://docs.railway.app/",
  },
  {
    id: 20,
    icon: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcpanel-svgrepo-com.svg?alt=media&token=7554c1e6-a7d0-4245-bf2a-afd7957ea05b",
    title: "CPANEL",
    alt: "Cpanel logo",
    description: `${techDescription.cpanelDesc}`,
    class: "icons",
    progress: 75,
    variant: "success",
    category: `${categories.cpanelCat}`,
    typeOfTech: `${typeOfTech.cpanelTech}`,
    docs: "https://docs.cpanel.net/cpanel/",
  },
];
